import { kebabCase } from 'lodash';

const itemForGroup = (menuItems, item, type) => {
  const mi = menuItems.find(d => d.id === item.menu_item.id);
  const { id, slug } = item.menu_item;
  return { id, slug, type: kebabCase(type), ...mi.data };
};

const nameForItem = (menuItems, id) => {
  let name;

  try {
    const item = menuItems.find(i => i.id === id);
    name = item?.data?.name ?? 'Borttagen produkt';
  } catch (e) {
    console.log(e);
  }

  return name;
};

const itemsForOrder = (order, menuItems) => {
  const items = order.items.map(i => {
    return {
      name: nameForItem(menuItems, i.id), ...i
    };
  });

  return items;
};

export { itemForGroup, nameForItem, itemsForOrder };
